export default {"src":"/_next/static/media/circleCheckMarkUiGreenWithLightBg_40.96f7bea8.svg","height":40,"width":40,"blurWidth":0,"blurHeight":0};